import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import setIRMData from '../../actions/rms/setIRMData';
import type ProtectionViewState from 'owa-mail-protection-types/lib/schema/ProtectionViewState';
import { protectionStore } from '../../store/protectionStore';
import getEncryptionInfoBarMessageId from './getEncryptionInfoBarMessageId';
import RightsManagementFailureCode from 'owa-mail-store/lib/store/schema/RightsManagementFailureCode';
import type RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';
import type BodyType from 'owa-service/lib/contract/BodyType';
import type { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function protectMessage(
    protectionViewState: ProtectionViewState,
    infoBarHostViewState: InfoBarHostViewState,
    templateId: string,
    bodyType: BodyType
): boolean {
    const { IRMData } = protectionViewState;
    const { rmsTemplates } = protectionStore;
    // Set IRM data when
    // 1. IRMData is null, or
    // 2. IRMData is of a different template type
    if (!IRMData || IRMData.RmsTemplateId != templateId) {
        if (IRMData) {
            removeInfoBarMessage(
                infoBarHostViewState,
                getEncryptionInfoBarMessageId(IRMData.RmsTemplateId)
            );
        }
        const newIRMData = createIRMData(bodyType, rmsTemplates.get(templateId));
        if (newIRMData) {
            setIRMData(protectionViewState, newIRMData);
            addInfoBarMessage(
                infoBarHostViewState,
                getEncryptionInfoBarMessageId(newIRMData.RmsTemplateId)
            );
            return true;
        }
    }
    return false;
}

export function createIRMData(
    bodyType: BodyType,
    sourceData: RightsManagementLicenseDataType
): RightsManagementLicenseDataType {
    const userConfig = getUserConfiguration();
    let licenseData: RightsManagementLicenseDataType;
    if (sourceData) {
        licenseData = {
            RmsTemplateId: sourceData.RmsTemplateId,
            IsOwner: true,
            RightsManagedMessageDecryptionStatus: RightsManagementFailureCode.Success,
            TemplateName: sourceData.TemplateName,
            TemplateDescription: sourceData.TemplateDescription,
            BodyType: bodyType,
            ContentOwner: userConfig.SessionSettings.UserEmailAddress,
            EditAllowed: false,
            ReplyAllowed: false,
            ReplyAllAllowed: false,
            ForwardAllowed: false,
            PrintAllowed: false,
            ExtractAllowed: false,
            ProgrammaticAccessAllowed: false,
        };
    }
    return licenseData;
}
